/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLightbulb: {
  name: 'lightbulb';
  data: string;
} = {
  name: 'lightbulb',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 3a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0V3Zm-4 9a3 3 0 1 1 4.5 2.6 1 1 0 0 0-.5.865V20h-2v-4.535a1 1 0 0 0-.5-.866C9.602 14.08 9 13.11 9 12Zm3-5a5 5 0 0 0-3 9v4a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-4a5 5 0 0 0-3-9Zm6 5a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1ZM3 11a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H3Zm1.793-6.207a1 1 0 0 1 1.414 0l1.5 1.5a1 1 0 0 1-1.414 1.414l-1.5-1.5a1 1 0 0 1 0-1.414Zm14.414 1.414a1 1 0 0 0-1.414-1.414l-1.5 1.5a1 1 0 0 0 1.414 1.414l1.5-1.5Z" fill="currentColor"/></svg>`,
};
